import React, { useEffect } from 'react';
import { WithTestIdOptional } from 'shared-client/types/test';
import useDelayedDisplay from './hooks/useDelayedDisplay';
import { useVisuallyHiddenAnnouncement } from './hooks/useVisuallyHiddenAnnouncement';

/**
 * Type definition for all possible color options.
 *
 */
export type SpinnerColor = 'default' | 'dark' | 'light';

interface SpinnerProps extends WithTestIdOptional {
	waitMs: number;
	color: SpinnerColor;
	centered: boolean;
	className?: string;
}

/**
 * Spinner SVG for loading purposes
 *
 * @returns
 */
function Spinner(props: SpinnerProps) {
	const display = useDelayedDisplay(props.waitMs);
	const { setVisuallyHiddenAnnouncement } = useVisuallyHiddenAnnouncement();

	useEffect(() => {
		if (display) {
			setVisuallyHiddenAnnouncement('Loading');
		}

		return () => {
			if (display) {
				setTimeout(() => {
					setVisuallyHiddenAnnouncement('Finished Loading');
				}, 200);
			}
		};
	}, [setVisuallyHiddenAnnouncement, display]);

	if (!display) {
		return null;
	}

	const spinnerDefaultClass = 'spinner ';
	const spinnerColorClass = 'spinner--' + props.color + ' ';
	const spinnerCenterClass = props.centered ? 'spinner--centered ' : '';
	const testId = `spinner-${props.testId ? props.testId : 'default'}`;

	const spinnerClass =
		spinnerDefaultClass + spinnerColorClass + spinnerCenterClass + (props.className ? props.className : '');

	return (
		<div className={spinnerClass} data-testid={testId}>
			<div className="spinner__cube1" />
			<div className="spinner__cube2" />
		</div>
	);
}

Spinner.defaultProps = {
	waitMs: 200,
	color: 'default',
	centered: false,
};

export default React.memo(Spinner);
